import React from 'react';
import { Bar } from '@nivo/bar';

export default function BarChart({ data, layout, name }) {
  const axisBottom = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: name === 'members' ? 0 : -30,
  

  };

  const axisLeft = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
  };
  
  var truncateData = data.map((item) => {
   // truncating the length of labels with length more than 10 chars 
      if(item.name.length>10)
      {
         return({...item,fullname: item.name,  name:item.name.slice(0,10)+"..."})}
      else
      {  
        return ({...item,fullname: item.name,})}
    })
    
  

  return (
    <Bar
      width={name === 'bucket' ? 700 : 550}
      height={400}
      margin={{ top: 30, right: 0, bottom: 60, left: 80 }}
      data={truncateData}
      keys={['not_started', 'late', 'in_progress', 'completed']}
      indexBy='name'
      labelTextColor='inherit:darker(2.4)'
      labelSkipWidth={12}
      labelSkipHeight={12}
      enableLabel={false}
      layout={layout}
      enableGridX={name === 'members' ? true : false}
      enableGridY={name === 'members' ? false : true}
      axisBottom={axisBottom}
      axisLeft={axisLeft}
      padding={0.75}
      //   custom tooltip
      tooltip={function (e) {
        return (
          <div className='bg-white border border-gray3 py-1 px-2  border-opacity-50 shadow-lg rounded-lg'>
            <p className='text-lg text-gray font-bold w-min'>{e?.data?.fullname}</p>
            <div className='flex items-center space-x-2'>
              <span
                className={`w-4 h-4 p-1 rounded-sm ${
                  e.id === 'completed'
                    ? 'bg-[#28B446]'
                    : e.id === 'late'
                    ? 'bg-[#d13438]'
                    : e.id === 'not_started'
                    ? 'bg-[#828282]'
                    : 'bg-[#1D75E7]'
                }`}
              ></span>
              <p className='text-gray3'>
                {e.id} : {e.value}
              </p>
            </div>
          </div>
        );
      }}
      defs={[
        {
          id: 'dots',
          type: 'patternDots',
          background: 'rgba(130, 130, 130)',
          color: 'rgba(130, 130, 130)',
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: 'lines',
          type: 'patternDots',
          background: 'rgba(29, 117, 231)',
          color: 'rgba(29, 117, 231)',
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: 'almost',
          type: 'patternDots',
          background: 'rgba(209, 52, 56)',
          color: 'rgba(209, 52, 56)',
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: 'complete',
          type: 'patternDots',
          background: 'rgba(40, 180, 70)',
          color: 'rgba(40, 180, 70)',
          size: 4,
          padding: 1,
          stagger: true,
        },
      ]}
      fill={[
        {
          match: {
            id: 'not_started',
          },
          id: 'dots',
        },
        {
          match: {
            id: 'in_progress',
          },
          id: 'lines',
        },
        {
          match: {
            id: 'late',
          },
          id: 'almost',
        },
        {
          match: {
            id: 'completed',
          },
          id: 'complete',
        },
      ]}
    />
  );
}
